import { datadogRum } from '@datadog/browser-rum';

import { parseBoolean } from '../utils/parserUtils';

const COMPANY_PROPERTY = 'company';

function isDisabled() {
  return parseBoolean(process.env.GATSBY_DATADOG_DISABLED);
}

function setUser(currentUser) {
  if (isDisabled()) return;

  datadogRum.setUser({
    id: currentUser.id,
    name: currentUser.name,
    email: currentUser.email,
    phone: currentUser.phone,
    role: currentUser.role
  });
}

function clearUser() {
  if (isDisabled()) return;

  datadogRum.clearUser();
  datadogRum.removeGlobalContextProperty(COMPANY_PROPERTY);
}

function setCompany(currentCompany) {
  datadogRum.setGlobalContextProperty(COMPANY_PROPERTY, {
    id: currentCompany.id,
    name: currentCompany.name
  });
}

export default { setUser, clearUser, setCompany };
